import React from 'react';
import TenantManager from '../../../../components/tenantManager';
import tenants from './tenants';

class TimesheetActionsDialog extends React.Component {
    render() {
        return <TenantManager {...tenants} {...this.props} />;
    }
}

export default TimesheetActionsDialog;



// WEBPACK FOOTER //
// ./src/pages/timekeeping/dialogs/timesheetActions/index.jsx